import React, { useEffect, useState } from "react";
import "./AdminProfiles.css";

import { vandalAuth } from "../../utils/Auth";

function AdminProfiles(props) {
  const [formValues, setFormValues] = useState({
    LoginInput: "",
    PasswordInput: "",
    SearchInput: "",
    NewPassInput: "",
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  }

  const [users, setUsers] = useState([]);

  const [newUser, setNewUser] = useState(false);
  const [newPass, setNewPass] = useState(false);
  const [newPassId, setNewPassId] = useState("");

  function getUsers() {
    vandalAuth.getAllUser().then((data) => {
      if (data.message === "Список пользователей успешно получен.") {
        setUsers(data.users);
        console.log(users);
        console.log(data);
      }
    });
  }

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <div className="AdminProfiles">
      <div className="AdminProfiles__popup">
        <div className="AdminProfiles__popup__header">
          <p className="AdminProfiles__popup__header__title">Сотрудники</p>
          <button
            onClick={() => {
              props.setNewUser(false);
            }}
            type="button"
            className="AdminProfiles__popup__header__btn"
          >
            Закрыть панель
          </button>
        </div>

        <div className="AdminProfiles__popup__search">
          {!newUser ? (
            <>
              <input
                type="text"
                placeholder="Поиск сотрудников"
                className="AdminProfiles__popup__search__input"
                value={formValues.SearchInput}
                onChange={handleChange}
                name="SearchInput"
              />
              <button
                onClick={() => {
                  setFormValues({
                    ...formValues,
                    SearchInput: "",
                  });
                  setNewUser(true);
                }}
                type="button"
                className="AdminProfiles__popup__search__btn"
              >
                Добавить сотрудника
              </button>
            </>
          ) : (
            <>
              <input
                type="text"
                placeholder="Имя сотрудника"
                className="AdminProfiles__popup__search__input"
                value={formValues.LoginInput}
                onChange={handleChange}
                name="LoginInput"
              />
              <input
                type="text"
                placeholder="Пароль сотрудника"
                className="AdminProfiles__popup__search__input"
                value={formValues.PasswordInput}
                onChange={handleChange}
                name="PasswordInput"
              />
              <button
                type="button"
                className="AdminProfiles__popup__search__btn"
                onClick={() => {
                  vandalAuth
                    .register(formValues.PasswordInput, formValues.LoginInput)
                    .then((data) => {
                      if (
                        data.message === "Пользователь успешно зарегистрирован"
                      ) {
                        console.log(data);
                        getUsers();
                        setFormValues({
                          ...formValues,
                          LoginInput: "",
                          PasswordInput: "",
                        });
                        setNewUser(false);
                      }
                    });
                }}
              >
                Добавить сотрудника
              </button>

              <button
                onClick={() => {
                  setFormValues({
                    ...formValues,
                    LoginInput: "",
                    PasswordInput: "",
                  });
                  setNewUser(false);
                }}
                type="button"
                className="AdminProfiles__popup__search__btn"
              >
                отмена
              </button>
            </>
          )}
        </div>
        <div className="AdminProfiles__popup__table">
          <table className="AdminProfiles__popup__tables">
            <thead>
              <tr>
                <th>Имя сотрудника</th>
                <th>Тип аккаунта</th>
                <th colSpan="3">Действие с аккаунтом</th>
              </tr>
            </thead>
            <tbody>
              {users.map((row) => (
                <tr key={row.id}>
                  <td>{row.login}</td>
                  <td>
                    {row.admins === "yes"
                      ? "Высший администратор"
                      : "сотрудник"}{" "}
                  </td>
                  <td>
                    {newPass && newPassId === row.id ? (
                      <input
                        type="text"
                        className="AdminProfiles__popup__table__input"
                        placeholder="Введите новый пароль"
                        name="NewPassInput"
                        value={formValues.NewPassInput}
                        onChange={handleChange}
                      />
                    ) : (
                      <button
                        onClick={() => {
                          let admins =
                            row.admins === "yes"
                              ? "remove-admin"
                              : "assign-admin";
                          vandalAuth
                            .changeAdmin(admins, row.id)
                            .then((data) => {
                              if (
                                data.message ===
                                  "Права администратора успешно удалены." ||
                                data.message ===
                                  "Пользователь стал администратором."
                              ) {
                                getUsers();
                              }
                            });
                        }}
                      >
                        {row.admins === "yes"
                          ? "Понизить до стандартного"
                          : "Повысить до высшего"}
                      </button>
                    )}
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        if (newPass === true) {
                          vandalAuth
                            .changePassw(row.id, formValues.NewPassInput)
                            .then((data) => {
                              if (data.message === "Пароль успешно изменен.") {
                                setNewPass(false);
                                setNewPassId("");
                                setFormValues({
                                  ...formValues,
                                  NewPassInput: "",
                                });
                              }
                            });
                        }
                        setNewPass(true);
                        setNewPassId(row.id);
                      }}
                    >
                      Сбросить пароль
                    </button>
                  </td>
                  <td>
                    {newPass && newPassId === row.id ? (
                      <button
                        onClick={() => {
                          setNewPass(false);
                          setFormValues({
                            ...formValues,
                            NewPassInput: "",
                          });
                        }}
                      >
                        Отмена
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          vandalAuth.deleteUser(row.id).then((data) => {
                            if (
                              data.message === "Пользователь успешно удален."
                            ) {
                              getUsers();
                            }
                          });
                        }}
                      >
                        Удалить аккаунт
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminProfiles;
